import React, { useState, useEffect } from 'react';
import { scrollToFirstErrorField } from '../../utils/scrollToFirstError';
import { useNavigate } from 'react-router-dom';
import { useBackendAuth } from '../../hooks/useAuth';
import AdminHeader from '../components/AdminHeader';

const AdminLogin = () => {
    const { user, loading, login } = useBackendAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!loading && user) {
            navigate('/admin', { replace: true });
        }
    }, [loading, user, navigate]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError('');

        try {
            await login(email, password);
        } catch {
            setError('Login failed. Please check your credentials.');
            setIsSubmitting(false);
            scrollToFirstErrorField();
        }
    };

    if (loading && !isSubmitting) {
        return (
            <div className="flex min-h-dvh items-center justify-center px-4">
                <div className="h-16 w-16 animate-spin rounded-full border-t-4 border-b-4 border-indigo-600" />
            </div>
        );
    }

    return (
        <>
            <AdminHeader />
            <div className="flex min-h-dvh items-center justify-center bg-gray-100 px-4 pb-8 pt-20">
                <form onSubmit={handleSubmit} className="w-full max-w-md space-y-6 rounded-lg bg-white p-6 shadow-lg sm:p-8">
                    <h2 className="text-center text-2xl font-bold">Admin Login</h2>

                    {error && <p className="text-red-600 text-center">{error}</p>}

                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        required
                        className="w-full rounded border p-3 text-base"
                    />
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        required
                        className="w-full rounded border p-3 text-base"
                    />

                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full rounded bg-indigo-600 py-3 font-medium text-white hover:bg-indigo-700 disabled:opacity-50"
                    >
                        {isSubmitting ? 'Logging in...' : 'Login as Admin'}
                    </button>
                </form>
            </div>
        </>
    );
};

export default AdminLogin;